"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarRentalsOfferStatus = exports.ConfirmationStatus = exports.CarSupplier = exports.CarPaymentCategory = exports.ErrorType = exports.FeeType = exports.TransmissionType = exports.SteeringType = void 0;
exports.SteeringType = {
    HYDRAULIC: "hydraulic",
    ELETRIC: "eletric",
    COMMON: "common",
};
exports.TransmissionType = {
    MANUAL: "manual",
    AUTOMATIC: "automatic",
};
exports.FeeType = {
    SERVICE_FEE: "serviceFee",
    RETURN_FEE: "returnFee",
};
var ErrorType;
(function (ErrorType) {
    ErrorType["EXTERNAL"] = "EXTERNAL";
    ErrorType["INTERNAL"] = "INTERNAL";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var CarPaymentCategory;
(function (CarPaymentCategory) {
    CarPaymentCategory["AgencyBilled"] = "AGENCY_BILLED";
    CarPaymentCategory["CompanyBilled"] = "COMPANY_BILLED";
    CarPaymentCategory["Balcony"] = "BALCONY";
})(CarPaymentCategory = exports.CarPaymentCategory || (exports.CarPaymentCategory = {}));
var CarSupplier;
(function (CarSupplier) {
    CarSupplier["LOCALIZA"] = "localiza";
    CarSupplier["MOVIDA"] = "movida";
})(CarSupplier = exports.CarSupplier || (exports.CarSupplier = {}));
(function (CarPaymentCategory) {
    CarPaymentCategory["AGENCY_BILLED"] = "AGENCY_BILLED";
    CarPaymentCategory["COMPANY_BILLED"] = "COMPANY_BILLED";
    CarPaymentCategory["BALCONY"] = "BALCONY";
})(CarPaymentCategory = exports.CarPaymentCategory || (exports.CarPaymentCategory = {}));
var ConfirmationStatus;
(function (ConfirmationStatus) {
    ConfirmationStatus["CONFIRMED"] = "confirmed";
    ConfirmationStatus["FAILED"] = "failed";
    ConfirmationStatus["NOT_SURE"] = "not_sure";
})(ConfirmationStatus = exports.ConfirmationStatus || (exports.ConfirmationStatus = {}));
var CarRentalsOfferStatus;
(function (CarRentalsOfferStatus) {
    CarRentalsOfferStatus["Added"] = "added";
    CarRentalsOfferStatus["Pending"] = "pending";
    CarRentalsOfferStatus["Booked"] = "booked";
    CarRentalsOfferStatus["Emitted"] = "emitted";
    CarRentalsOfferStatus["Canceled"] = "canceled";
    CarRentalsOfferStatus["Failed"] = "failed";
    CarRentalsOfferStatus["NotSure"] = "not_sure";
})(CarRentalsOfferStatus = exports.CarRentalsOfferStatus || (exports.CarRentalsOfferStatus = {}));
